import {
  IonItem,
  IonLabel,
  IonLoading,
  IonSelect,
  IonSelectOption,
} from "@ionic/react";
import React, { useContext, useEffect, useState } from "react";
import { TranslationsContext } from "../util/Translations";
import { PlannedListFilterType } from "../pages/MaterialIssue";
import {
  saveUserValue,
  getDefaultFilterForIssueScreen,
} from "../api/UserSetups";
import {
  DEFAULT_FILTER_USER_PARAMETER,
  DEFAULT_FILTER_USER_SECTION,
} from "../util/Constants";

const DefaultFilterForIssueScreen: React.FC = () => {
  const { translations } = useContext(TranslationsContext);
  const [defaultFilter, setDefaultFilter] = useState<PlannedListFilterType>(
    PlannedListFilterType.ItemsNotFullyIssued
  );
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    setShowLoading(true);
    getDefaultFilterForIssueScreen()
      .then((value) => {
        setDefaultFilter(value);
      })
      .finally(() => {
        setShowLoading(false);
      });
  }, []);

  const saveDefaultFilter = async (filterValue: PlannedListFilterType) => {
    setDefaultFilter(filterValue);
    const data = {
      UserParameter: DEFAULT_FILTER_USER_PARAMETER,
      UserSection: DEFAULT_FILTER_USER_SECTION,
      UserValue: !filterValue
        ? PlannedListFilterType.ItemsNotFullyIssued
        : filterValue,
    };
    setShowLoading(true);
    await saveUserValue(data);
    setShowLoading(false);
  };

  return (
    <>
      <IonLoading
        isOpen={showLoading}
        onDidDismiss={() => setShowLoading(false)}
        duration={5000}
      />
      <IonItem>
        <IonLabel position="stacked">
          {translations["lbl_mob_defaultfilter_issuescreen"] ||
            "Default Filter for Issue Screen"}
        </IonLabel>
        <IonSelect
          interface="popover"
          value={defaultFilter}
          onIonChange={(ev) => {
            saveDefaultFilter(ev.detail.value);
          }}
        >
          <IonSelectOption value={PlannedListFilterType.ItemsNotFullyIssued}>
            {PlannedListFilterType.ItemsNotFullyIssued}
          </IonSelectOption>
          <IonSelectOption value={PlannedListFilterType.All}>
            {PlannedListFilterType.All}
          </IonSelectOption>
          <IonSelectOption
            value={PlannedListFilterType.AvailableItemsNotFullyIssued}
          >
            {PlannedListFilterType.AvailableItemsNotFullyIssued}
          </IonSelectOption>
        </IonSelect>
      </IonItem>
    </>
  );
};

export default DefaultFilterForIssueScreen;
